<template>
  <span>
    <v-btn
      @click.stop="setDialog(true)"
      aria-label="Show Help Text"
      color="grey darken-1"
      fab
      icon
      small
      title="Show Help Text"
    >
      <v-icon small>far fa-question-circle</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <h1 class="questionText">{{ question.text }}</h1>
        </v-card-title>
        <v-card-text>
          <v-divider class="mt-1 mb-4"></v-divider>
          <div class="my-1">{{ question.helpText }}</div>
          <div class="mt-3" v-if="answerList.length">
            <div v-for="(answer, index) in answerList" :key="index">
              <ul>
                <li class="my-3">
                  <div>
                    <span class="bodyText--text font-weight-bold"
                      >Answer {{ index + 1 }}:</span
                    >
                    <span class="font-italic ml-1">{{ answer.text }}</span>
                  </div>
                  <div>{{ answer.helpText }}</div>
                </li>
              </ul>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="setDialog(false)"
            aria-label="Close Help Text"
            color="primary"
            outlined
            small
            text
            title="Close Help Text"
            top
            >close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    setDialog(val) {
      this.dialog = val;
    },
  },
  props: ["answerList", "question"],
};
</script>
<style scoped>
.questionText {
  word-break: normal !important;
}
</style>
